declare const ENVIRONMENT: 'development' | 'production' | 'staging';

export const IS_DEV = ENVIRONMENT === 'development';
export const IS_PROD = ENVIRONMENT === 'production';
export const IS_STAGING = ENVIRONMENT === 'staging'
